module.exports = __webpack_public_path__ + "static/media/logo-omni.f2aa9289.png";